import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { BaseComponent, UserService, ProductService } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-skeleton-loader",
  templateUrl: "skeleton-loader.component.html",
  standalone: false,
})
export class SkeletonLoaderComponent extends BaseComponent implements OnInit {
  @Input() type: string;
  @Input() width: string;
  @Input() height: string | number;
  @Input() borderRadius: string;
  @Input() maxWidth: string;
  @Input() number: number = 1;
  @Input() extraContainerClass: string;
  @Input() useRandomWidth: boolean = false;

  public instances: Array<any>;

  randomWidths: any = {};

  /**
   * Line lengths for `community-post-row`, cycled per row. Fixed rather than random so the
   * placeholders don't jump around if the loader re-renders, and varied so a column of them
   * reads as a list of different posts rather than one shape repeated.
   */
  readonly rowWidths = [
    { subject: "72%", body: "94%", bodyEnd: "58%" },
    { subject: "54%", body: "88%", bodyEnd: "70%" },
    { subject: "64%", body: "96%", bodyEnd: "42%" },
  ];

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit() {
    let arr = [];
    for (let i = 0; i < this.number; i++) {
      arr.push(i);
    }
    this.instances = arr;
    if (this.useRandomWidth) {
      this.instances.forEach((line, index) => {
        this.randomWidths[index] = Math.floor(Math.random() * 60) + 40 + "%";
      });
    }
  }
}
